module.exports = __webpack_public_path__ + "media/music/a7c08a472cc8b1c4e0c45ae9b030b414.mp3";